export const uk = {
    'success-change': 'Продукт успешно обновлен'
};
